import { NmSidebarItem } from '../widgets/sidebar/sidebar.interface';

export let config: NmSidebarItem[] = [
	{
		icon: 'tachometer',
		name: 'DashBoard',
		href: '/dashboard'
	},

	{
		icon: 'users',
		name: 'Members',
		child: [
			{ name: 'Search', href: '/members/search' },
			{ name: 'Report', href: '/members/report' },
			{ name: 'Add New Member', href: '/members/create' },
			{ name: 'Batch Upload', href: '/members/batchupload' },
			{ name: 'Send Passwords', href: '/members/sendpwd' },
			 { name: 'Manual match', href: '/members/pending' },
			// { name: 'Account Aggregation', href: '/members/account-aggregation' },
			// { name: 'Account Blocking Rules Setup', href: '/members/account-blocking-rules-setup' },
		],
	},

	{
		icon: 'building',
		name: 'Schools',
		child: [
			{ name: 'Search', href: '/schools/search' },
			{ name: 'Report', href: '/schools/report' },
			{ name: 'Add New School', href: '/schools/create' },
		],
	},
	{
		icon: 'user',
		name: 'Teachers',
		child: [
			{ name: 'Search', href: '/teachers/search' },
			{ name: 'Report', href: '/teachers/report' },
			{ name: 'Add New Teacher', href: '/teachers/create' },
		],
	},
	{
		icon: 'gears',
		name: 'Configuration',
		child: [
			{ name: 'Email templates', href: '/email-tpls/list' },
		],
	},


	{
		icon: 'user-circle',
		name: 'Users',
		href: '/users',
	},
];


// WEBPACK FOOTER //
// ./src/config/sidebar.config.ts